export default "__VITE_ASSET__DeeU832W__"